<div class="home-container">
    <h1><img style="height: 2em;" src="./assets/wachter/images/WachterLogo-Gradient - Cropped.png"> wApps</h1>
    <hr />
    <!-- <h2>
Welcome to wApps!
</h2>
<p>
wApps is a rapid application development (RAD) platform. With wApps, Wachter’s AppDev team can quickly create prototypes, get user feedback and rapidly release solutions to the wild! Best of all, wApps plays nicely with your desktop or mobile device browser! For more information or if you feel you have a project for the wApps team, please contact <a href="mailto:support@wachter.com?subject=wApps Project">support</a>.
</p> -->

    <dw-content-manager configKey="wachter-home">
        <h2>
            <dw-content name="title" display="Page Title" [controlType]="textboxControlType">
                Welcome to wApps!
            </dw-content>
        </h2>

        <dw-content name="detail" display="Header Details">
            wApps is a rapid application development (RAD) platform. With wApps, Wachter’s AppDev team can quickly
            create prototypes, get user feedback and rapidly release solutions to the wild! Best of all, wApps plays
            nicely with your desktop or mobile device browser! For more information or if you feel you have a project
            for the wApps team, please contact <a href="mailto:support@wachter.com?subject=wApps Project">support</a>.

        </dw-content>

        <dw-content-component name='component' display='Covid Section'>


        </dw-content-component>
    </dw-content-manager>
</div>